// import { Headline3, Label2 } from "@bms-ai/bms-ai-ui-lib/components";
import type { ManuscriptPreviewData } from "../../context/MultipleFileUploadContext";

interface ManuscriptPreviewProps {
  previewData: ManuscriptPreviewData | null;
  // manuscriptPreviewContent: string;
}

const ManuscriptPreview: React.FC<ManuscriptPreviewProps> = ({
  previewData,
  // manuscriptPreviewContent,
}) => {
  return (
    <div className="preview-section">
      {/* <div className="preview-header-sticky">
        <Headline3 className="preview-section-label">
          Manuscript Preview
        </Headline3>
        <Label2 className="preview-section-subtext">
          Content extracted from the uploaded manuscript file
        </Label2>
      </div> */}
      <div className="preview-area preview-area-filled">
        <div className="manuscript-content-container">
          <div className="manuscript-content">
            {previewData ? (
              // Use API data
              previewData.full_content.map((content, index) => {
                if (content.type === "paragraph" && content.text) {
                  return <p key={index}>{content.text}</p>;
                }
                if (content.type === "table" && content.data) {
                  return (
                    <table key={index} className="manuscript-table">
                      <tbody>
                        {content.data.map((row: string[], rowIndex: number) => (
                          <tr key={rowIndex}>
                            {row.map((cell: string, cellIndex: number) => (
                              <td key={cellIndex}>
                                {cell.split('\n').map((line, lineIndex) => (
                                  <span key={lineIndex}>
                                    {line}
                                    {lineIndex < cell.split('\n').length - 1 && <br />}
                                  </span>
                                ))}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  );
                }
                return null;
              })
            ) : (
              // Fallback to mock data
              <div>No preview available for the uploaded manuscript.</div>
              // manuscriptPreviewContent.split("\n").map((line, index) => {
              //   // Handle headers
              //   if (line.startsWith("## ")) {
              //     return <h2 key={index}>{line.substring(3)}</h2>;
              //   }
              //   if (line.startsWith("### ")) {
              //     return <h3 key={index}>{line.substring(4)}</h3>;
              //   }
              //   // Handle bold text
              //   if (line.startsWith("**") && line.endsWith("**")) {
              //     return <strong key={index}>{line.slice(2, -2)}</strong>;
              //   }
              //   // Handle list items
              //   if (line.startsWith("- ")) {
              //     return <li key={index}>{line.substring(2)}</li>;
              //   }
              //   // Handle horizontal rules
              //   if (line === "---") {
              //     return <hr key={index} />;
              //   }
              //   // Handle regular paragraphs
              //   if (line.trim()) {
              //     return <p key={index}>{line}</p>;
              //   }
              //   // Handle empty lines
              //   return <br key={index} />;
              // })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManuscriptPreview;
